<template>
  <div>
    <b-list-group-item
      :to="{ path: item.href, query: { name: item.title } }"
      class="text-light bg-dark list-group-expand"
      @click="onLinkClick(item)"
    >
      <span>{{ item.title }}</span>
    </b-list-group-item>
    <b-list-group v-if="item.child" class="child-list">
      <side-bar-item
        v-for="childItem in item.child"
        :key="childItem.title"
        :item="childItem"
        @dashboardSelected="onLinkClick"
      />
    </b-list-group>
  </div>
</template>

<script>
export default {
  name: 'SideBarItem',
  props: { item: Object },
  methods: {
    onLinkClick(item) {
      if (item.href) {
        this.$emit('dashboardSelected', item.title);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.list-group {
  padding: 0;
  overflow: hidden;
}

.list-group-item {
  border-radius: 0;
  border-width: 1px 0 0 0;
  padding: 0.2em 1em;
}

.list-group > .list-group-item:first-child {
  border-top-width: 0;
}

.child-list .list-group-item {
  text-indent: 1em;
}
</style>